export default __webpack_public_path__ + "static/media/mill.9a56791e.svg";